/** @jsx jsx */
import { jsx } from 'theme-ui';
import { FC, useEffect, useState } from 'react';
import { graphql } from 'gatsby';
import faker from 'faker';

import Layout from '../ui-components/layout';

import FullScreenImage from '../components/full-screen-image/full-screen-image';
import Text from '../components/text/text';
import SEO from '../components/seo/seo';
import FilteredCardsSection from '../components/cards/filtered-cards';

export interface Curriculum {
  id: string;
  name: string;
  image: {
    file: {
      url: string;
    };
  };
  lessonNumber: number;
  experienceYear: number;
  experienceQuarter: number;
  skillsTaught: string[];
  gradeLevel: string[];
  practice: string[];
  concepts: string[];
  length: number;
  category: string[];
  deviceOsSupport: string[];
  summary: {
    summary: string;
  };
  newUrl: string;
  cardUrl: string;
}

interface CurriculumHubProps {
  data: {
    site: {
      siteMetadata: {
        name: string;
        tagline: string;
        githubLink: string;
      };
    };
    contentfulCurriculumHub: {
      id: number;
      metaTitle: string;
      metaDescription: {
        metaDescription: string;
      };
      noIndexnoFollow: boolean;
      socialMediaImage: {
        file: {
          url: string;
        };
      };
      slug: string;
      teacherResources: boolean;
      language: [];
      sections: [];
    };
    curriculum: {
      edges: [
        {
          node: Curriculum;
        }
      ];
    };
  };
  pageContext: any;
}

export const curriculumHubQuery = graphql`
  query($slug: String!, $curriculumCategory: String!) {
    contentfulCurriculumHub(slug: { eq: $slug }) {
      id
      metaTitle
      metaDescription {
        metaDescription
      }
      socialMediaImage {
        file {
          url
        }
      }
      slug
      language
      teacherResources
      sections {
        ...FullScreenImageSection
      }
    }
    curriculum: allContentfulCurriculum(
      sort: {lessonNumber: ASC}
      filter: {category: {eq: $curriculumCategory}}
    ) {
      edges {
        node {
          id
          name
          image {
            ...ContentfulAsset
          }
          lessonNumber
          experienceYear
          experienceQuarter
          practice
          concepts
          length
          category
          deviceOsSupport
          summary {
            summary
          }
          newUrl
        }
      }
    }
  }
`;

// ...TextSection
// ...AlternatingImageSection

const CurriculumHub: FC<CurriculumHubProps & JSX.IntrinsicElements['div']> = ({
  className = '',
  id = '',
  data: {
    curriculum,
    contentfulCurriculumHub: {
      sections,
      metaTitle,
      metaDescription,
      socialMediaImage,
      language,
      slug,
      noIndexnoFollow,
      teacherResources = false
    }
  },
  ...rest
}) => {
  const components = {
    ContentfulFullScreenImageSection: FullScreenImage,
    // ContentfulAlternatingImageSection: AlternatingImage,
    // ContentfulRichTextSection: RichTextSection,
    // ContentfulPodcastSection: PodcastSection,
    ContentfulTextSection: Text
    // ContentfulVideoSection: VideoSection
  };

  const ComponentMatch = data => {
    const MatchingComponent = components[data.internal.type];
    return <MatchingComponent data={data} />;
  };

  // makes link for card
  curriculum.edges.map(({node}) => {
    if (teacherResources) {
      node.cardUrl = node.newUrl;
    } else {
      node.cardUrl = node.newUrl && node.newUrl.slice(0, node.newUrl.lastIndexOf('/')).concat('/student-portal').replace('lesson-plan', 'lesson');
    }
  })

  return (
    <Layout>
      <SEO
        title={metaTitle}
        description={metaDescription.metaDescription}
        image={socialMediaImage.file.url}
        pathname={slug}
        lang={language}
        noIndexNoFollow={noIndexnoFollow}
      />
      {sections.map((component: any) => (
        <ComponentMatch
          {...component}
          key={component.heading || component.title}
        />
      ))}
      <FilteredCardsSection
        data={curriculum.edges}
        keysToFilterOn={[
          'experienceYear',
          'experienceQuarter',
          'practice',
          'concepts',
          'length'
        ]}
      />
    </Layout>
  );
};

export default CurriculumHub;
